module.exports = __webpack_public_path__ + "static/media/thumbnail-campanhaTriibo.d19b7037.png";